<template>
  <modal-dialog
    @click="close"
    :show="show"
    :title="title"
    :instructions="instructions"
    :dialogInputs="dialogInputs"
    @onClose="close"
    @onSubmit="submit()"
  ></modal-dialog>
</template>

<script>
import ModalDialog from "@/components/dialogs/modalDialog.vue";

/*
 * This is a base component of a input-form dialog.
 * Extend this component and override data properties and the submit method to handle form submissions
 */
export default {
  name: "BaseDialog",
  props: { show: Boolean },
  components: { ModalDialog },
  computed: {
    dialogInputs: {
      get() {
        return [];
      }
    },
    title: {
      get() {
        return "";
      }
    },
    instructions: {
      get() {
        return "";
      }
    }
  },

  methods: {
    close: function() {
      this.$emit("onClose");
    },
    submit() {
      this.title = "Oops...";
      this.instructions =
        "You need to extend this base component and override this the submit method";
    }
  }
};
</script>


// WEBPACK FOOTER //
// baseDialog.vue?79b20a58